/**
=========================================================
* Arakan - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";

// Settings page components
import FormField from "components/FormField";

import crudsService from "services/cruds-service";
import { Autocomplete, Chip, Switch, TextField } from "@mui/material";
import MDInput from "components/MDInput";
import i18n from "i18n";

function MainInfo({
  project,
  setProject,
  categories,
  tags,
  faqs,
  allStatus,
  countries,
  targetSegments,
  periodTypes,
  changeHandler,
  autoSwitchChangeHandler,
  info,
  setErrors,
  errors,
  notification,
  setNotification,
}) {
  const { t } = i18n;

  return (
    <>
      <Card id="basic-info" sx={{ overflow: "visible" }}>
        <MDBox p={3}>
          <MDTypography variant="h5">بيانات المشروع</MDTypography>
        </MDBox>
        <MDBox pb={3} px={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <FormField
                onChange={changeHandler}
                variant="outlined"
                label="الرابط"
                name="slug"
                value={info.slug || ""}
                placeholder={"slug"}
                error={errors.slug}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <FormField
                onChange={changeHandler}
                label="عدد المستفيدين"
                variant="outlined"
                type="number"
                name="benficial_num"
                value={info.benficial_num || 0}
                placeholder="benficial_num"
                error={errors.benficial_num}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <FormField
                onChange={changeHandler}
                variant="outlined"
                label="lisence"
                name="lisence"
                value={info.lisence || ""}
                placeholder={"lisence"}
                error={errors.lisence}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <FormField
                onChange={changeHandler}
                variant="outlined"
                type="number"
                label="الترتيب"
                name="sequence"
                value={info.sequence || 10000}
                placeholder={"sequence"}
                error={errors.sequence}
              />
            </Grid>
            {/* <Grid item xs={12} lg={3}>
              <FormField
                variant="outlined"
                type="number"
                onChange={changeHandler}
                label="المدة"
                name="period"
                value={info.period || ""}
                placeholder={"period"}
                error={errors.period}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <Autocomplete
                options={periodTypes}
                name="period_type"
                renderOption={(props, option) => (
                  <li {...props} key={option?.id}>
                    {option.data ? option.data.name : option.name}
                  </li>
                )}
                getOptionLabel={(option) => {
                  if (option.data) {
                    if (option.data.name) return option.data.name;
                  } else {
                    if (option) {
                      if (option.name) return option.name;
                    }
                  }
                  return "";
                }}
                isOptionEqualToValue={(option, item) =>
                  option === item || option?.id === item?.id
                }
                renderInput={(params) => (
                  <MDInput
                    variant="outlined"
                    {...params}
                    label="يوم/شهر/سنة"
                    error={errors.period_type}
                  />
                )}
                onChange={(e, v) => autoSwitchChangeHandler("period_type", v)}
                value={info?.period_type}
              />
            </Grid>

            <Grid item xs={12} lg={3}>
              <Autocomplete
                variant="outlined"
                options={countries}
                name="impl_country_id"
                renderOption={(props, option) => (
                  <li {...props} key={option?.id}>
                    {option.data ? option.data.name : option.name}
                  </li>
                )}
                getOptionLabel={(option) => {
                  if (option.data) {
                    if (option.data.name) return option.data.name;
                  } else {
                    if (option) {
                      if (option.name) return option.name;
                    }
                  }
                  return "";
                }}
                isOptionEqualToValue={(option, item) =>
                  option === item || option?.id === item?.id
                }
                renderInput={(params) => (
                  <MDInput
                    variant="outlined"
                    {...params}
                    //variant="standard"
                    label="بلد التنفيذ"
                    error={errors.impl_country_id}
                  />
                )}
                value={info.impl_country_id || null}
                onChange={(e, v) =>
                  autoSwitchChangeHandler("impl_country_id", v)
                }
              />
            </Grid> */}
            <Grid item xs={12} lg={4}>
              <Autocomplete
                options={allStatus}
                name="status_id"
                renderOption={(props, option) => (
                  <li {...props} key={option?.id}>
                    {option.data ? option.data.name : option.name}
                  </li>
                )}
                getOptionLabel={(option) => {
                  if (option.data) {
                    if (option.data.name) return option.data.name;
                  } else {
                    if (option) {
                      if (option.name) return option.name;
                    }
                  }
                  return "";
                }}
                isOptionEqualToValue={(option, item) =>
                  option === item || option?.id === item?.id
                }
                renderInput={(params) => (
                  <MDInput
                    variant="outlined"
                    {...params}
                    //variant="standard"
                    label="الحالة"
                    error={errors.status_id}
                  />
                )}
                onChange={(e, v) => autoSwitchChangeHandler("status_id", v)}
                value={info.status_id || null}
              />
            </Grid>

            <Grid item xs={12} lg={4}>
              <Autocomplete
                multiple
                options={targetSegments}
                name="target_segments"
                value={info.target_segments || []}
                onChange={async (event, v, reason, detail) => {
                  if (project.id) {
                    if (reason === "removeOption") {
                      const removedItem = project?.target_segments.find(
                        (orgItem) => orgItem?.id === detail.option?.id,
                      );
                      let arr = project.target_segments.filter(
                        (segment) => segment?.id !== detail.option?.id,
                      );
                      setProject({ ...project, target_segments: arr });
                      removedItem?.id &&
                        (await crudsService.removeItemWithFilter(
                          `items/projects_target_segment`,
                          {
                            query: {
                              filter: {
                                target_segment_id: { _eq: removedItem?.id },
                                projects_id: { _eq: project?.id },
                              },
                            },
                          },
                        ));
                    } else if (reason === "selectOption") {
                      let arr = project.target_segments;
                      arr.push(detail.option);
                      setProject({ ...project, target_segments: arr });
                      await crudsService.createItem(
                        `items/projects_target_segment`,
                        {
                          target_segment_id: detail.option?.id,
                          projects_id: project?.id,
                        },
                      );
                    }
                  }
                  autoSwitchChangeHandler("target_segments", v);
                }}
                renderOption={(props, option) => {
                  const { key, ...rest } = props;
                  return (
                    <li key={key} {...rest}>
                      {option.data ? option.data.name : option.name}
                    </li>
                  );
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return (
                      <Chip
                        key={option.id || key}
                        {...tagProps}
                        label={option.data?.name || option.name}
                      />
                    );
                  })
                }
                getOptionLabel={(option) =>
                  option?.data?.name || option?.name || ""
                }
                isOptionEqualToValue={(option, item) => option?.id === item?.id}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    variant="outlined"
                    label="الفئة المستهدفة"
                    error={errors.target_segments}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <Autocomplete
                multiple
                options={categories}
                name="categories"
                value={info.categories || []}
                onChange={async (event, v, reason, detail) => {
                  if (project.id) {
                    if (reason === "removeOption") {
                      const removedItem = project?.categories.find(
                        (orgItem) => orgItem?.id === detail.option?.id,
                      );
                      let arr = project.categories.filter(
                        (category) => category?.id !== detail.option?.id,
                      );
                      setProject({ ...project, categories: arr });
                      await crudsService.removeItemWithFilter(
                        `items/projects_categories`,
                        {
                          query: {
                            filter: {
                              categories_id: { _eq: removedItem?.id },
                              projects_id: { _eq: project?.id },
                            },
                          },
                        },
                      );
                    } else if (reason === "selectOption") {
                      let arr = project.categories;
                      arr.push(detail.option);
                      setProject({ ...project, categories: arr });
                      await crudsService.createItem(
                        `items/projects_categories`,
                        {
                          categories_id: detail.option?.id,
                          projects_id: project?.id,
                        },
                      );
                    }
                  }
                  autoSwitchChangeHandler("categories", v);
                }}
                renderOption={(props, option) => {
                  const { key, ...rest } = props;
                  return (
                    <li key={key} {...rest}>
                      {option.data ? option.data.name : option.name}
                    </li>
                  );
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return (
                      <Chip
                        key={option.id || key}
                        {...tagProps}
                        label={option.data?.name || option.name}
                      />
                    );
                  })
                }
                getOptionLabel={(option) =>
                  option?.data?.name || option?.name || ""
                }
                isOptionEqualToValue={(option, item) => option?.id === item?.id}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    variant="outlined"
                    label="التصنيفات"
                    error={errors.categories}
                  />
                )}
              />
            </Grid>
            {/* <Grid item xs={12} lg={4}>
              <Autocomplete
                multiple
                options={tags}
                name="tags"
                value={info.tags || []}
                onChange={async (event, v, reason, detail) => {
                  if (project.id) {
                    if (reason === "removeOption") {
                      const removedItem = project?.tags.find(
                        (orgItem) => orgItem?.id === detail.option?.id
                      );
                      let arr = project.tags.filter(
                        (tag) => tag?.id !== detail.option?.id
                      );
                      setProject({ ...project, tags: arr });
                      await crudsService.removeItemWithFilter(
                        `items/projects_tags`,
                        {
                          query: {
                            filter: {
                              tags_id: { _eq: removedItem?.id },
                              projects_id: { _eq: project?.id },
                            },
                          },
                        }
                      );
                    } else if (reason === "selectOption") {
                      let arr = project.tags;
                      arr.push(detail.option);
                      setProject({ ...project, tags: arr });
                      await crudsService.createItem(`items/projects_tags`, {
                        tags_id: detail.option?.id,
                        projects_id: project?.id,
                      });
                    }
                  }
                  autoSwitchChangeHandler("tags", v);
                }}
                renderOption={(props, option) => {
                  const { key, ...rest } = props;
                  return (
                    <li key={key} {...rest}>
                      {option.data ? option.data.name : option.name}
                    </li>
                  );
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return (
                      <Chip
                        key={option.id || key}
                        {...tagProps}
                        label={option.data?.name || option.name}
                      />
                    );
                  })
                }
                getOptionLabel={(option) =>
                  option?.data?.name || option?.name || ""
                }
                isOptionEqualToValue={(option, item) => option?.id === item?.id}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    variant="outlined"
                    label="الوسوم"
                    error={errors.tags}
                  />
                )}
              />
            </Grid> */}
            <Grid item xs={12} lg={4}>
              <Autocomplete
                multiple
                options={faqs}
                name="faqs"
                value={info.faqs || []}
                onChange={async (event, v, reason, detail) => {
                  if (project.id) {
                    if (reason === "removeOption") {
                      const removedItem = project?.faqs.find(
                        (orgItem) => orgItem?.id === detail.option?.id,
                      );
                      let arr = project.faqs.filter(
                        (faq) => faq?.id !== detail.option?.id,
                      );
                      setProject({ ...project, faqs: arr });
                      await crudsService.removeItemWithFilter(
                        `items/projects_faq`,
                        {
                          query: {
                            filter: {
                              faq_id: { _eq: removedItem?.id },
                              projects_id: { _eq: project?.id },
                            },
                          },
                        },
                      );
                    } else if (reason === "selectOption") {
                      let arr = project.faqs;
                      arr.push(detail.option);
                      setProject({ ...project, faqs: arr });
                      await crudsService.createItem(`items/projects_faq`, {
                        faq_id: detail.option?.id,
                        projects_id: project?.id,
                      });
                    }
                  }
                  autoSwitchChangeHandler("faqs", v);
                }}
                renderOption={(props, option) => {
                  const { key, ...rest } = props;
                  return (
                    <li key={key} {...rest}>
                      {option.data ? option.data.name : option.name}
                    </li>
                  );
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    const { key, ...questionProps } = getTagProps({ index });
                    return (
                      <Chip
                        key={option.id || key}
                        {...questionProps}
                        label={option.data?.name || option.name}
                      />
                    );
                  })
                }
                getOptionLabel={(option) =>
                  option?.data?.name || option?.name || ""
                }
                isOptionEqualToValue={(option, item) => option?.id === item?.id}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    variant="outlined"
                    label="faqs"
                    error={errors.faqs}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                <MDBox mt={0.5}>
                  <Switch
                    // onChange={changeHandler}
                    name="zakaat_available"
                    checked={!!info.zakaat_available}
                    onChange={() =>
                      autoSwitchChangeHandler(
                        "zakaat_available",
                        !info.zakaat_available,
                      )
                    }
                  />
                </MDBox>
                <MDBox width="80%" ml={0.5}>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    تجوز الزكاة
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={4}>
              <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                <MDBox mt={0.5}>
                  <Switch
                    // onChange={changeHandler}
                    name="urgent"
                    checked={!!info.urgent}
                    onChange={() =>
                      autoSwitchChangeHandler("urgent", !info.urgent)
                    }
                  />
                </MDBox>
                <MDBox width="80%" ml={0.5}>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    الأشد إحتياج
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Grid>
            {/* <Grid item xs={12} lg={4}>
              <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                <MDBox mt={0.5}>
                  <Switch
                    // onChange={changeHandler}
                    name="all_amount_required"
                    checked={!!info.all_amount_required}
                    onChange={() =>
                      autoSwitchChangeHandler(
                        "all_amount_required",
                        !info.all_amount_required,
                      )
                    }
                  />
                </MDBox>
                <MDBox width="80%" ml={0.5}>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    عطاءات
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Grid> */}
          </Grid>
        </MDBox>
      </Card>
    </>
  );
}

export default MainInfo;
